export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/cloud-04.10dd2bd8-3e4525.svg";